/**
 * E-004 — shared elapsed-time formatter for operator session timers.
 *
 * Extracted out of TerminalModeView (where it previously lived inline) so the
 * standard Verification Station header and the terminal-mode stats bar render
 * the session duration identically. Produces a clock-style elapsed string at
 * one-second granularity:
 *   - under an hour:  `M:SS`   (e.g. "1:05", "0:09")
 *   - one hour+:      `H:MM:SS` (e.g. "1:01:01")
 */
export function formatDuration(ms: number): string {
  const totalSeconds = Math.floor(Math.max(0, ms) / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  if (hours > 0) {
    return `${hours}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
  }
  return `${minutes}:${String(seconds).padStart(2, "0")}`;
}
